<template>

<com-item name="player.profile" :size="size" :loading="loading" theme="blue" class="profile-wrapper">

	<template v-slot:stats>

        <div class="profile">

            <div class="profile-head" :style="{backgroundImage: backgroundImage}">

                <core-avatar type="player" :item="player" class="profile-avatar" :not-linked="true" />

            </div>
        
            <div class="profile-name">{{ player.name }}</div>

			<div class="profile-items">

				<div class="profile-item">

					<div class="profile-item-value">{{ player.totalPlays | prettyNumber }}</div>
					<div class="profile-item-text">plays</div>
						
				</div>

				<div class="profile-item">

					<div class="profile-item-value">{{ player.totalGames | prettyNumber }}</div>
					<div class="profile-item-text">games</div>
						
				</div>

				<div class="profile-item">

					<div class="profile-item-value">{{ player.hindex }}</div>
					<div class="profile-item-text">h-index</div>
						
				</div>
			</div>

        </div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

        backgroundImage: function() {

            var i = Math.floor(Math.random() * this.games.length);
            
            return 'url(' + this.$util.thumbnail.game.large(this.games[i].g) + ')'

        },

		player: function() {

			return this.$store.getters['page/insights/player/player']

		},

		loading: function() {

			return this.fetching === 'all' 

		},

		games: function() {

			return this.$store.getters['page/insights/player/games'].games

		},

		data: function() {

			return this.$store.getters['page/insights/player/player']

		},

		active: function() {

			return this.data && !this.loading

		}

	}

}

</script>

<style scoped>

.profile {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.is-mobile .profile-wrapper >>> .insights-item-content {
	height: 360px;
}

.profile-head {
    height: 180px;
    width: 100%;
    border-radius: 4px 4px 0px 0px;
    background-position: 50% 50%;
    background-size: cover;
    margin-bottom: 40px;
}

.profile-avatar {
    position: absolute!important;
    left: 50%;
    bottom: -20px;
    margin-left: -48px;
    width: 96px;
    border: 4px solid #fff;
    height: 96px;
}

.profile-avatar >>> .avatar-initial {
    font-size: 32px;
}

.profile-name {
    font-size: 20px;
    margin-bottom: 14px;
    font-weight: 500;
    color: #fff;
}

.profile-items {
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
}

.profile-item {
	width: 33.3%;
	display: flex;
	flex-direction: column;
}

.profile-item-value {
	align-items: center;
	display: flex;
	color: #fff;
	height: 64px;
	font-weight: 500;
	font-size: 28px;
	justify-content: center;
}

.profile-item-value >>> span.currency {
	font-size: 14px;
}

.profile-item-value > div {
	height: 64px;
	display: flex;
	align-items: center;
}

.profile-item-text {
	height: 16px;
	flex-shrink: 0;
	color: #fff;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
}

</style>